import React, {useReducer, useEffect} from "react";

import {validate} from "./util/validators";
import "./Input.css";

const inputReducer = (state, action) => {
  switch (action.type) {
    case "CHANGE":
      return {
        ...state,
        value: action.val,
        isValid: validate(action.val, action.validators),
      };
    case "TOUCH": {
      return {
        ...state,
        isTouched: true,
      };
    }
    case "ENTERED": {
      return {
        ...state,
        isEntered: true,
      };
    }
    default:
      return state;
  }
};

const Input = (props) => {
  const [inputState, dispatch] = useReducer(inputReducer, {
    value: props.value || "",
    isTouched: false,
    isEntered: false,
    isValid: props.valid || false,
  });

  const {id, onInput, onTyped, onEntered} = props;
  const {value, isValid} = inputState;

  useEffect(() => {
    onInput(id, value, isValid);
  }, [id, value, isValid, onInput]);

  const changeHandler = (event) => {
    const pointer = event.target.selectionStart;
    const element = event.target;

    window.requestAnimationFrame(() => {
      element.selectionStart = pointer;
      element.selectionEnd = pointer;
    });

    if (props.onlyNumbers === true) {
      if (!/^[0-9]*$/.test(event.target.value)) {
        return;
      }
    }
    dispatch({
      type: "CHANGE",
      val: event.target.value,
      validators: props.validators,
    });

    if (onTyped) {
      onTyped(event.target.value);
    }
  };

  const touchHandler = () => {
    dispatch({
      type: "TOUCH",
    });
  };

  const keyDownHandler = (event) => {
    if (event.keyCode === 13) {
      dispatch({
        type: "ENTERED",
      });
      if (onEntered) {
        onEntered();
      }
    }
  };

  let element = (
    <textarea
      id={props.id}
      rows={props.rows || 3}
      onChange={changeHandler}
      onKeyDown={keyDownHandler}
      onBlur={touchHandler}
      placeholder={props.placeholder}
      disabled={props.isDisabled}
      value={props.value}
    />
  );

  if (props.element === "input") {
    element = (
      <input
        id={props.id}
        type={props.type}
        placeholder={props.placeholder}
        onChange={changeHandler}
        onKeyDown={keyDownHandler}
        onBlur={touchHandler}
        value={props.value}
        disabled={props.isDisabled}
      />
    );
  }

  return (
    <div
      className={`form-control ${
        !inputState.isValid && inputState.isTouched && "form-control--invalid"
      } form-control--${props.variant || "default"}`}
    >
      {props.label && props.label !== "NA" && (
        <label htmlFor={props.id}>{props.label}</label>
      )}
      {element}
    </div>
  );
};

export default Input;
